 <!--Intro Section-->
 <section class="view intro-2 posi"
    style="background-image: url(../../../../assets/img/we-are-teliya.png);
           background-size: cover; background-repeat: no-repeat; height: 80%;">
    <div class="mask rgba-gradient">
        <div class="container h-100 d-flex justify-content-center align-items-center">
          <div class="flex-center pt-5 mt-3">
            <div class="text-center text-md-left margins">
              <div class="white-text" >
                <h1 class="text-center" style="font-size:4rem; font-weight: bold; line-height: 1em; color: white;" > {{ "pages.pabout.weAre" | translate }} </h1>
                <hr class="hr-light mt-5 line-un">
                <br>
              </div>
            </div>
          </div>
        </div>
        </div>
  </section>


  <section class="backcolor">

    <section class="container">
      <div class="content-header">
        <h2 class="size-33 teta text-center" style="color:#033b55"> {{"pages.pabout.weAct" | translate }} </h2>
        <div class="row">
          <!--Grid column-->
        <div class="col-md-4 offset-md-1 text-center">
            <img class="bd-placeholder-img" width="260px" height="245px" src="../../../../assets/img/parcours-patient.png" alt="">
        </div>
        <div class="col-md-7">
         <p class="text-center size-22 pt-5" style="line-height: 1.3em; margin: 5px;">
          {{ "pages.pabout.teliyaMake" | translate }}
         </p>
        </div>
        <!--Grid column-->

        </div>
      </div>
    </section>

    <section id="banner-7" class="bg-scroll wide-100 info-section division mt-5" style="background-image: url(../../../../assets/img/our-mission.png); color: white;">
          <div class="container white-color">

             <div class="row d-flex align-items-center">

               <!-- BANNER TEXT -->
               <div class="col-md-8 col-lg-7 col-xl-6">
                <div class="banner-txt wow fadeInUp" data-wow-delay="0.4s">

                  <!-- Title  -->
                  <h2 class="h2-xs text-center size-33" style="color:#033b55"> {{ "pages.pabout.ourMissionTitle" | translate }} </h2>

                    <!-- Text -->
                    <p class="size-22 text-center" style="line-height: 1.3em;">{{ "pages.pabout.ourMission" | translate }}</p>
                    <p class="size-15 text-center" style="line-height: 1.3em;"> <img src="../../../../assets/img/odd3.8.png" width="50px" height="50px" alt=""> {{ "pages.pabout.ODD3_8" | translate }}</p>


                </div>
              </div>	<!-- END BANNER TEXT -->


            </div>      <!-- End row -->
          </div>	    <!-- End container -->
    </section>

    <section id="info-5" class="bg-scroll wide-100 info-section division" style="background-image: url(../../../../assets/img/our-vision.png); color: black;">
          <div class="container mt-5">
            <div class="row d-flex align-items-center">


              <!-- TEXT BLOCK -->
              <div class=" col-xs-12 col-sm-10 offset-sm-1 col-md-8 col-lg-6 col-xl-6 offset-md-2 offset-lg-5 offset-xl-6 offset-lg-6">
                <div class="banner-txt wow fadeInUp" data-wow-delay="0.4s" style="background-color: white; opacity: 0.8; height: 100%; width: 100%;" >

                      <!-- Title  -->
                  <h2 class="h2-xs text-center size-33 pt-5" style="color:#033b55"> {{ "pages.pabout.ourVisionTitle" | translate }} </h2>

                    <p class="size-22 text-center" style="line-height: 1.3em;">
                      {{ "pages.pabout.ourVision" | translate }}
                    </p>


                </div>
              </div>	<!-- END TEXT BLOCK -->


            </div>    <!-- End row -->
          </div>	   <!-- End container -->
    </section>

    <section id="banner-7" class="bg-scroll wide-100 info-section division mt-5" style="background-image: url(../../../../assets/img/notre-equipe.png); background-size: cover; color: black;">
          <div class="container white-color">

             <div class="row d-flex align-items-center">

               <!-- BANNER TEXT -->
               <div class="col-md-12 col-lg-12 col-xl-12" style="  width: 100%;">
                <div class="txt-block pc-30 white-color text-center wow fadeInUp" data-wow-delay="0.4s">


                  <h2 class="h2-xs text-center size-33 pt-3" style="color:#033b55">{{ "pages.pabout.ourTeam" | translate }}</h2>
                  <p class="size-22" style="line-height: 1.3em;">{{ "pages.pabout.ourTeamD0" | translate }} </p>
                  <p class="size-22" style="line-height: 1.3em;">&bull; {{ "pages.pabout.ourTeamD1" | translate }} .</p>
                  <p class="size-22" style="line-height: 1.3em;">&bull; {{ "pages.pabout.ourTeamD2" | translate }} </p>
                 <p class="size-22" style="line-height: 1.3em;"> &bull; {{ "pages.pabout.ourTeamD3" | translate }} </p>
                 <p class="size-22">
                   <span class="text-center"><a style="font-weight: bold;" routerLink="/contact"> {{"contactUsLink" | translate }} </a></span>
                 </p>
  

                </div>
              </div>	<!-- END BANNER TEXT -->


            </div>      <!-- End row -->
          </div>	    <!-- End container -->
    </section>

  </section>
